import React from "react";
import { useTranslation } from "react-i18next";
import { ContractStatus } from "../../features/contracts/models/ContractStatus";

/** Status pill for contracts — green while active, neutral when on hold or ended. */
const ContractStatusBadge: React.FC<{ status: ContractStatus }> = ({ status }) => {
  const { t } = useTranslation();
  const classes: Record<ContractStatus, string> = {
    [ContractStatus.Active]: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300",
    [ContractStatus.OnHold]: "bg-secondary-95 text-secondary-30 dark:bg-secondary-20 dark:text-secondary-80",
    [ContractStatus.Cancelled]: "bg-grey-95 text-grey-50 dark:bg-primary-20 dark:text-grey-60",
  };

  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-medium ${classes[status]}`}>
      {t(`billing.contractStatus.${status}`, { defaultValue: status })}
    </span>
  );
};

export default ContractStatusBadge;
